import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';

import {MunshiMenu} from "../components/Menu";
import {CustomerSelect} from "../components/Select/CustomerSelect";

import dayjs from "dayjs";



import {LocationSelect} from "../components/Select/LocationSelect";
import {Button} from 'primereact/button';
import {Serial} from "../components/Serial/serialEdit"
import Modal from 'react-bootstrap/Modal';
import {Sidebar} from "primereact/sidebar";

import {jDateToMySql, ToMySqlDate} from "../utilities/ToMySqlDate";
import {PurchasePrint} from "../print/purchasePrint";
import PurchaseTools from "../components/Purchase/purchaseToolBar";
import {PurchaseScroll} from "../components/Purchase/purchaseScroll";
import {PurchaseBody} from "../components/Purchase/PurchaseBody";
import {PurchaseRadio} from "../components/Purchase/PurchaseRadio";

import {v4 as uuidv4} from "uuid";
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import _ from "lodash";

import {ToastContainer} from "react-toastify";
import {Scanner} from "../components/Image/ImageUtils";
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";
import {sF, sI} from "../utilities/NumberFormatter";
import {InputNumber} from "primereact/inputnumber";
import {Calendar} from "primereact/calendar";
import {FloatLabel} from "primereact/floatlabel";
import {Auths} from "../utilities/getAuthDep";


function Purchase({handle}) {
    const [roNumber, setRoNumber] = useState(0);
    const [invNumber, setInvNumber] = useState(0);
    const [contentList, setContentList] = useState([]);
    const [customer, setCustomer] = useState({name: "", id: 0, initialBalance: 0, customerGroup: 0});
    const [iDate, setIDate] = useState(new Date());
    const [refreshList, setRefreshList] = useState(false);
    const [location, setLocation] = useState({id: 0, name: "", customerId: 0});
    const [isPosted, setPosted] = useState(false);
    const [enableGlobalEdit, setEnableGlobalEdit] = useState(!isPosted);
    const [total, setTotal] = useState(0);
    const [vat, setVat] = useState(0);
    const [serialList, setSerialList] = useState([]);
    const [show, setShow] = useState(false);
    const [visible, setVisible] = useState(false);
    const [purchaseList, setPurchaseList] = useState([])
    const [showPrint, setShowPrint] = useState(false)
    const [body, setBody] = useState([])
    const [header, setHeader] = useState({})
    const [showImage, setShowImage] = useState(false)
    const [selection, setSelection] = useState("Purchase")
    const [companyName, setCompanyName] = useState("")
    const [database, setDatabase] = useState("")
    const [user, setUser] = useState();
    const [level] = useState(Auths);
    const [locationList, setLocationList] = useState([])
    const [customerList, setCustomerList] = useState([])
    const [itemList, setItemList] = useState([])
    const {loading, setLoading} = useSpinner()
    useEffect(() => {
        setLocation(locationList[0])
    }, [setLocation, locationList])

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [locRes, bioRes, itemRes, custRes] = await Promise.all([
                    axiosInstance.get('location'),
                    axiosInstance.get('biodata/'),
                    axiosInstance.get('item'),
                    axiosInstance.get('customer')
                ]);

                setLocationList(locRes.data);
                setVat(sF(bioRes.data.vat));
                setCompanyName(bioRes.data.name);
                setItemList(itemRes.data);
                setCustomerList(custRes.data);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        setLoading(true);
        axiosInstance.get("purchase/")
            .then((response) => {
                if (response && response.data.length > 0) {
                    setPurchaseList(response.data.reverse());
                } else {
                    setPurchaseList([]);
                }
            })
            .catch((error) => {
                notify(error.message, "error");
            }).finally(() => {
            setLoading(false);
        })
    }, [refreshList, setRefreshList]);
    //Loader//
    useEffect(() => {
        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') );

    }, [])
    //Action//
    const setAct = useCallback((act) => {
        if (act !== "") {
            switch (act) {
                case "ADD":
                    renewPurchase();
                    break;
                case "SAVE":
                    if (customer && customer.id > 0 && !isPosted && contentList && contentList.length > 0 && contentList[0].itemName !== undefined) {
                        setLoading(true);

                            // If Warranty: overwrite comment on every row with RO number (as a string)
                            const bodyToSave =
                                selection === "Warranty"
                                    ? contentList.map((row) => ({
                                          ...row,
                                          comment: 'RO-'+String(roNumber ?? ""),
                                      }))
                                    : contentList;

                        const ttl = bodyToSave.reduce((a, b) => a + sF(b.total), 0);
                        const vt = ttl * sF(vat) / 100;

                        axiosInstance.post('purchase', {
                            header: {
                                id: invNumber,
                                customerId: customer.id,
                                customerName: customer.name,
                                date: jDateToMySql(iDate),
                                warranty: selection === "Warranty",
                                import: selection === "Import",
                                posted: false,
                                location: location,
                                total: ttl,
                                vat: vt,
                            },
                            body: bodyToSave,
                            serial: serialList
                        }).then((response) => {
                            if (response.data === 0) {
                                notify("Purchase could not be saved. Please try again.", "error")
                                setInvNumber(0);
                                setRefreshList(!refreshList);
                            } else {
                                notify("Purchased Saved Successfully", "success")
                                setInvNumber(response.data);
                                setRefreshList(!refreshList);
                            }
                        }).catch((error) => {
                            notify(error.message, "success")
                        }).finally(() => {
                            setLoading(false);

                        })
                    } else {
                        notify("Please fill all the fields.", "success");
                    }
                    break;
                case "UNDO":
                    renewPurchase();
                    break;
                case "DELETE":
                    if (invNumber > 0) {
                        setLoading(true);
                        axiosInstance.delete(`purchase/${invNumber}`).then((response) => {
                            if (response.data === 0) {
                                notify("Purchase could not be deleted. Please try again.", "error")
                            } else {
                                notify("Purchase Deleted Successfully", "success")
                                setInvNumber(0);
                                renewPurchase();
                                setRefreshList(!refreshList);
                            }
                        }).catch((error) => {
                            notify(error.message, "success");
                        }).finally(
                            () => {
                                setLoading(false)

                            }
                        )
                    } else {
                        notify("Purchase is not approved. Please approve the invoice first.", "success")
                    }
                    break;
                case "POST" :
                    if (!isPosted && invNumber > 0 && selection !== "Warranty" && level.posting()) {
                        setLoading(true);
                        axiosInstance.get(`purchase/post/id/${invNumber}`).then((response) => {
                            if (response.data === 0) {
                                notify(`Purchase ${invNumber} could not be posted. Please try again.`, "error")
                                setPosted(false)
                            } else {
                                notify(`Purchase ${invNumber} Posted Successfully`, "success");
                                setRefreshList(!refreshList);
                                setPosted(true)
                                setEnableGlobalEdit(false)
                            }
                        }).catch((error) => {
                            notify(error.message, "success");
                        }).finally(() => {
                            setLoading(false)
                        })
                    } else if (selection === "Warranty") {
                        notify(
                            `Warranty ${invNumber} is not allowed to post directly `, "error");

                    } else if (isPosted && invNumber > 0) {
                        notify("Purchase is already posted. Please Un-post the invoice first.", "success")
                    }
                    break;
                case "UNPOST" :
                    if (isPosted && level.posting()) {
                        setLoading(true);
                        axiosInstance.get(`purchase/unpost/id/${invNumber}`).then((response) => {
                            if (response.data === 0) {
                                notify(`Purchase ${invNumber} could not be Un-posted. Please try again.`, "error")
                                setPosted(true)
                            } else {
                                notify(`Purchase ${invNumber} UnPosted Successfully`, "success");
                                setRefreshList(!refreshList);
                                setPosted(false)
                                setEnableGlobalEdit(true);
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(
                            () => {
                                setLoading(false)
                            }
                        )
                    } else {
                        notify("Purchase is not posted. Please post the purchase first.", "error")
                    }
                    break;
                case "PRINT" :
                    if (invNumber > 0) {
                        const body = Array.isArray(contentList) && contentList.length > 0
                            ? contentList.map((item) => ({
                                name: item.itemName,
                                quantity: item.quantity || 0,
                                price: item.price || 0,
                                total: (item.price || 0) * (item.quantity || 0),
                            }))
                            : [];
                        const header = {
                            invoiceId: invNumber,
                            customerName: customer.name,
                            date: ToMySqlDate(dayjs(iDate)),
                        }
                        setBody(body)
                        setHeader(header)
                        setShowPrint(true)

                    }
                    break;
                default:

                    break;
            }
        }
    }, [customer, isPosted, contentList, invNumber, iDate, selection, location, total, vat, serialList, refreshList])
//Reset//
    const renewPurchase = () => {
        setLocation(locationList[0])
        const dt = new Date();
        setIDate(dt);
        setPosted(false);
        setSelection("Purchase");
        setInvNumber(0)
        setTotal(0);
        setVat(0);
        setSerialList([]);
        setEnableGlobalEdit(true)
        setCustomer({name: "", id: 0, initialBalance: 0, customerGroup: 0})
        setContentList([
            {
                id: uuidv4(),
                invoiceId: 0,
                itemId: 0,
                itemName: "",
                quantity: 0,
                price: 0.0,
                total: 0,
                comment: ""
            }]);

    }
    const getPurchase = (invNum) => {
        if (invNum <= 0) return;

        const controller = new AbortController();
        const fetchPurchase = async () => {
            try {
                setLoading(true);
                // Fetch Invoice Data
                const invoiceResponse = await axiosInstance.get(`purchase/package/${invNum}`, {signal: controller.signal});
                if (!invoiceResponse.data || _.isEmpty(invoiceResponse.data)) {
                    notify("No purchase found with the given number.", "error");
                    return;
                }
                const validContent = invoiceResponse.data.content.map((item) => ({
                    ...item,
                    id: uuidv4(),
                    price: sF(item.price) || 0,
                    total: sF(item.total) || 0
                }));

                // Fetch Customer Data
                const customerResponse = await axiosInstance.get(`customer/id/${invoiceResponse.data.header.customerId}`, {signal: controller.signal});
                if (_.isEmpty(customerResponse.data)) {
                    notify("Customer not found.", "error");
                    return;
                    ;
                }
                // Set States
                setCustomer({
                    name: customerResponse.data.name,
                    id: customerResponse.data.id,
                    initialBalance: sF(customerResponse.data.initialBalance),
                    customerGroup: customerResponse.data.customerGroup,
                });
                setContentList(validContent);
                setSerialList(invoiceResponse.data.serial || []);
                setTotal(sF(invoiceResponse.data.header.total));
                setVat(sF(invoiceResponse.data.header.vat));
                // Handle Date Validation
                const invoiceDate = dayjs(invoiceResponse.data.header.date, "DD-MM-YYYY", true);
                if (invoiceDate.isValid()) {
                    setIDate(invoiceDate.toDate());
                } else {
                    notify("Invalid date format received from backend.", "error");
                    setIDate(new Date());

                }
                setSelection(invoiceResponse.data.header.status);
                setEnableGlobalEdit(!invoiceResponse.data.header.posted);
                setPosted(invoiceResponse.data.header.posted);
                // Set Statuses and Flags
                setLocation({
                    id: invoiceResponse.data.header.location.id,
                    name: invoiceResponse.data.header.location.name,
                });
                setInvNumber(invNum);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchPurchase();

        return () => {
            controller.abort(); // Cleanup
        };
    }


//Get Serial//
    const TopMenu = () => {
        return (
            <>
                <MunshiMenu handle={handle}/>

            </>
        )
    }
    const SerialList = () => {
        if (invNumber <= 0) return null;
        return (
            <Modal show={show} onHide={() => {
                setShow(false)
            }}>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Serial invoiceId={invNumber} setSerialList={setSerialList}
                            date={iDate ? iDate.toLocaleDateString() : ""}
                            mode={"PURC"} serialList={serialList} setShow={setShow} setAct={setAct}
                            customerName={customer ? customer.name : "No Customer"}/>
                </Modal.Body>

            </Modal>
        )
    }
    const SidebarContent = () => {
        return (
            <div className="flex flex-nowrap flex-shrink-1 justify-content-start align-content-start">
                <div className="card flex justify-content-center">
                    <Sidebar visible={visible} onHide={() => setVisible(false)}>
                        <PurchaseScroll purchases={invNumber} setInv={(invSelect) => getPurchase(invSelect)}
                                        refresh={refreshList}
                                        setVisible={setVisible} purchaseList={purchaseList}/>
                    </Sidebar>
                </div>
            </div>
        )
    }
    const HeaderForm = () => {
        return (
            <div className="flex flex-column w-8 md:w-3 h-auto m-5 headerFormDark">
                {!_.isEmpty(customer) && customerList &&
                    <FloatLabel>
                        <CustomerSelect customer={customer} setCustomer={setCustomer}
                                        disable={isPosted} loading={loading}
                                        customerList={customerList}/>
                        <label className="bg-black-alpha-30 text-white">Customer</label>
                    </FloatLabel>}

                {iDate &&
                    <FloatLabel className="mt-1">
                        <Calendar selectionMode={"single"} value={(iDate)} onChange={(e) => setIDate(e.value)} id={"dt"}
                                  dateFormat="dd/mm/yy" className={"h-2rem mt-1"} showIcon disabled={isPosted}/>
                        <label className={"mt-1 bg-black-alpha-30 text-white"} htmlFor="dt">Date</label>
                    </FloatLabel>}

                {location &&
                    <FloatLabel className="mt-1">
                        <LocationSelect setLocation={setLocation} id={"lc"} locationList={locationList}
                                        location={location} disable={isPosted}
                                        setLoading={setLoading}/>
                        <label className={"mt-1 bg-black-alpha-30 text-white"} htmlFor="lc">Location</label>
                    </FloatLabel>}
            </div>
        )
    }
    const Check = () => {
  const isNewInvoice = invNumber === 0;
  const isWarranty = selection === "Warranty";

  if (!isNewInvoice) return null;

  return (
    <div className="flex flex-column md:flex-row align-items-start md:align-items-center gap-3 w-full">
      <div className="flex align-items-center gap-3 p-2 md:p-3 border-1 border-white-alpha-20 border-round-lg bg-black-alpha-30 w-full md:w-auto">
        <PurchaseRadio
          selection={selection}
          setSelection={setSelection}
          enableGlobalEdit={enableGlobalEdit}
          level={level}
        />

        {isWarranty && (
          <div className="flex align-items-center gap-2">
            <span className="text-white-alpha-80 text-sm px-2 py-1 border-1 border-white-alpha-20 border-round-md bg-black-alpha-20">
              RO
            </span>

            <InputNumber
              value={roNumber}
              onFocus={(e) => e.target.select()}
              onValueChange={(e) => setRoNumber(sI(e.target.value))}
              disabled={!isWarranty}
              max={1000}
              size={10}
              showButtons
              minFractionDigits={0}
              inputClassName="text-right"
              className="h-2rem"
            />
          </div>
        )}
      </div>
    </div>
  );
};
    const handleImage = () => {
        setShowImage(true)
    }
    const ToolBar = () => {
        return (
            <>
                <div className="flex flex-nowrap flex-shrink-1 justify-content-start h-auto">
                    <div className="align-content-center">
                        <Button icon="pi pi-arrow-right" onClick={() => setVisible(true)}/>
                    </div>
                    <div className="flex flex-nowrap   ">
                        <PurchaseTools setAction={(action) => setAct(action)} enable={enableGlobalEdit}
                                       invNumber={invNumber} customerId={customer.id}/>

                    </div>
                    <div className="align-content-center h-auto">
                        <Button type="button" icon="pi pi-list" onClick={() => {
                            setShow(customer && customer.id > 0)
                        }}/>
                    </div>
                    <SerialList/>
                    <div className="align-content-center h-auto ml-1">
                        <Button type="button" icon="pi pi-image" disabled={invNumber === 0} onClick={handleImage}/>
                    </div>
                </div>
            </>
        )
    }
    if (showPrint && header && body) {
        return (
            <>
                <PurchasePrint header={header} body={body} setPrint={setShowPrint} setLoading={setLoading} vat={vat}
                               name={companyName}/>
            </>
        )
    } else if (!loading) {
            return (
                <div style={{ backgroundColor: "#1f1f1f", minHeight: "100vh" }}>
                    <ToastContainer/>
                    {showImage ? <Scanner loading={loading} setLoading={setLoading} invoice={invNumber} mode={"PURC"}
                                          showImage={showImage} setShowImage={setShowImage}/> : null}
                    <TopMenu/>
                    <div className="flex justify-content-between mt-1 ml-1">
                        <ToolBar/>
                        <div className="flex flex-nowrap flex-shrink-1 justify-content-end align-content-center">
                            <h1 className="font-bold text-center md:text-left align-self-center mr-4 text-base md:text-4xl text-white">
                                {selection} : {invNumber === 0 ? "New" : invNumber}
                            </h1>
                        </div>
                    </div>
                    <SidebarContent/>
                    <div className="flex w-full h-auto justify-content-around align-content-center">
                        <HeaderForm/>
                        <Check/>
                    </div>
                    <div className="flex w-full h-auto justify-content-center">
                        {!loading && <PurchaseBody list={contentList} setList={setContentList}
                                                   customerId={customer ? customer.id : 0}
                                                   enableGlobalEdit={enableGlobalEdit}
                                                   enableRowEdit={!isPosted} invoiceId={invNumber}
                                                   setLoading={setLoading}
                                                   loading={loading} vat={vat}
                                                   itemList={itemList} isPosted={isPosted}/>
                        }
                    </div>
                </div>
            );
        }
}


export default Purchase;
